import React from 'react';
import '../../App.css';
import './Zdroje.css';
import Footer from '../Footer';
import myFile1 from "./download/Accessible_Games_for_Blind_Children_Empo-1.pdf";
import myFile2 from "./download/AccessibleGames_RC1204.pdf"
import myFile3 from "./download/AccessibleProgramming_Cecily_Paper_2018.pdf"
import myFile4 from "./download/Cobirx_workingpaper.pdf"

import myFile5 from "./download/K04-Aaron.pdf"
import myFile6 from "./download/Recommended_Blocks4All.pdf"
import myFile7 from "./download/Recommended_Stefik_cse158-stefik.pdf"
import myFile8 from "./download/Programming Language Pragmatics.pdf"
import myFile9 from "./download/Diplomovka_Final.pdf"



export default function Zdroje() {
    return(
        <>
        <h1 className='zdroje'>Zdroje</h1>
        <div className = 'lit'> 
        
          <h1>Odborné články</h1>
          
           <ul className = 'ulstyle'>
             <li>
             <a href={myFile1} target = "_" > Accessible Games for Blind Children, Empowered by Binaural Sound</a>
             </li>

             <li>
             <a href={myFile2} target = "_" > Computer Games and Visually Impaired Peopled </a>
             </li>

             <li>
             <a href={myFile3} target = "_"> Making Programming Accessible to Learners with Visual </a>
             </li>

             <li>
             <a href={myFile4} target = "_"> COBRIX: A Physical Computing Interface for Blind and Visually Impaired Students to Learn Programming </a>
             </li>

             <li>
             <a href={myFile5} target = "_" > A principled approach to developing new languages for live coding </a>
             </li>

             <li>
             <a href={myFile6} target = "_" > Blocks4All: Overcoming Accessibility Barriers to Blocks Programming for Children with Visual Impairments </a>
             </li>

             <li>
             <a href={myFile7} target = "_" > On the Design of an Educational Infrastructure for the Blind and Visually Impaired in Computer Science </a>
             </li>

           </ul>

        </div>

        <div className = 'lit'>
          <h1>Kompilátory a interpretre</h1>
          <ul className = 'ulstyle'>
            <li>
            <a href=' https://edu.fmph.uniba.sk/~salanci/Kompilatory/index.html' target = "_" >Kompilátory a interpretre </a>
            </li>
            <li>
            <a href={myFile8} target = "_" > Programming Language Pragmatics </a>
            </li>
          </ul>
        </div>

        <div className = 'lit'>
          <h1>Diplomové práce</h1>
          <ul className = 'ulstyle'>
            <li>
            <a href={myFile9} target = "_" > Programovacie prostredie prístupné pre nevidiach žiakov nižšieho sekundárneho vzdelania </a>
            </li>
          </ul>
        </div>

        <div className = 'lit'>
          <h1>Dokumentácia</h1>
          <ul className = 'ulstyle'>
            <li>
            <a href='https://www.nvaccess.org/' target = "_">NVDA </a>
            </li>
            <li>
            <a href='https://www.jetbrains.com/idea/' target = "_" > Intellij IDEA </a>
            </li>
            <li>
            <a href='https://www.jetbrains.com/idea/' target = "_"> Java FX </a>
            </li>
            <li>
            <a href='https://docs.oracle.com/javase/accessbridge/2.0.2/setup.htm' target = "_" > Java Access Bridge </a>
            </li>
            <li>
            <a href='http://www.jfugue.org/' target = "_" > Music Programming for Java </a>
            </li>
          </ul>

        </div>
        
        <Footer />
        </>
      ) ;
}